<template>
  <div class="col-md-6">
    <div class="form-group">
      <p class="ml-0 mb-1">{{ type }} Items Description</p>
      <input
        type="text"
        v-bind:value="description"
        v-on:change="$emit('change', $event.target.value)"
        placeholder="Description of items to be picked up"
        class="form-control"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "BulkRequestDescription",
  model: {
    prop: 'description',
    event: 'change'
  },
  props: {
    type: String,
    description: String,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>